import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { INonUniqueVoucher } from '@/shared/model/non-unique-voucher.model';

const baseApiUrl = 'api/non-unique-vouchers';
const baseSearchApiUrl = 'api/_search/non-unique-vouchers?query=';

export default class NonUniqueVoucherService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<INonUniqueVoucher> {
    return new Promise<INonUniqueVoucher>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: INonUniqueVoucher): Promise<INonUniqueVoucher> {
    return new Promise<INonUniqueVoucher>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: INonUniqueVoucher): Promise<INonUniqueVoucher> {
    return new Promise<INonUniqueVoucher>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
